import React from 'react';
import PropTypes from 'prop-types';

import { Grid, Row, Col } from '@vds/grids';

import { StyledButtonWrapper } from './HomePhone.styles';

const ModalButton = (props) => {
  const { buttonName, onClickContinue, disabled, className } = props;

  return (
    <Grid>
      <Row className="noPadding">
        <Col colSizes={{ mobile: 4 }} className="pad20 onlyBottomPad">
          <StyledButtonWrapper secondary width="160px" size="large" disabled={disabled} onClick={onClickContinue} className={className}>
            {buttonName}
          </StyledButtonWrapper>
        </Col>
      </Row>
    </Grid>
  );
};

ModalButton.propTypes = {
  buttonName: PropTypes.string,
  onClickContinue: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};
export default ModalButton;
